import { DeleteAsync, GetAsync, PostAsync, PutAsync } from "src/common/httpRequests";
import { API_GATEWAY } from "src/constants/settings";
import { GenericApiResponse } from "src/@types/apis";
import { handleResponse } from "src/helpers/helpers";
import {
  ICreateDimensionPayload,
  IDimensionListResponse,
  IUpdateDimensionPayload,
} from "src/@types/dimension";
import { CATALOG_SERVICE_URL } from "src/constants/api";

const DIMENSION_BASE = `${API_GATEWAY}/${CATALOG_SERVICE_URL}/Dimension`;

export const getDimensionList = async (): Promise<
  GenericApiResponse<IDimensionListResponse>
> => {
  const response = await GetAsync(`${DIMENSION_BASE}/List`);
  return handleResponse<IDimensionListResponse>(response);
};

export const createDimension = async (
  payload: ICreateDimensionPayload,
): Promise<GenericApiResponse<any>> => {
  const response = await PostAsync(`${DIMENSION_BASE}/CreateDimension`, payload);
  return handleResponse<any>(response);
};

export const updateDimension = async (
  payload: IUpdateDimensionPayload,
): Promise<GenericApiResponse<any>> => {
  const response = await PutAsync(`${DIMENSION_BASE}/UpdateDimension`, payload);
  return handleResponse<any>(response);
};

export const deleteDimension = async (
  id: string,
): Promise<GenericApiResponse<any>> => {
  const response = await DeleteAsync(`${DIMENSION_BASE}/${id}`);
  return handleResponse<any>(response);
};
